import { useCallback, useMemo } from "react";
import { Button } from "../../../../externalComponents/tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../../externalComponents/tailwind/dialog";

const labels = Object.freeze({
  totalInSegment: "Number of contacts in the selected segment",
  optouts: "Contacts who have unsubscribed or opted out of communications",
  notOptouts: "Contacts who have not opted out of communications",
  optins: "Contacts who have given consent to receive communications",
});
const orderedKeys = ["optins", "optouts", "notOptouts", "totalInSegment"];

const ContactsBreakdownDialog = ({
  modalRef,
  setModalRef,
  contactsBreakdown,
}) => {
  const { contactsBreakdownMode } = modalRef;
  const sortedEntries = useMemo(
    () =>
      Object.entries(contactsBreakdown || {})
        .filter(([key]) => orderedKeys.includes(key))
        .sort((a, b) => orderedKeys.indexOf(a[0]) - orderedKeys.indexOf(b[0])),
    [contactsBreakdown, modalRef.contactsBreakdownMode],
  );

  const handleClose = useCallback(() => {
    setModalRef((_modalRef) => ({
      ..._modalRef,
      contactsBreakdownMode: 0,
    }));
  }, [modalRef.contactsBreakdownMode]);

  return (
    <Dialog open={contactsBreakdownMode} onClose={handleClose}>
      <DialogTitle>Contacts breakdown</DialogTitle>
      <DialogBody>
        <ul className="space-y-2">
          {sortedEntries.map(([key, value]) => (
            <li key={key} className="flex justify-between items-center">
              <span className="text-gray-600">{labels[key]}</span>
              <strong className="text-gray-800">{value}</strong>
            </li>
          ))}
        </ul>
      </DialogBody>
      <DialogActions>
        <Button color="primaryButton" onClick={handleClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactsBreakdownDialog;
